import React from 'react'
import './upcomingevents.css'
import EventContainer from './EventContainer/EventContainer'
import image1 from '../../../Assets/Images/SummerCamp/ec1.png'
import image2 from '../../../Assets/Images/SummerCamp/ec2.png'
import image3 from '../../../Assets/Images/SummerCamp/ec3.png'
import { MEDIA_LINKS, COMMON_THUMBNAIL_URL } from '../../../Constants/mediaLinks'

export default function UpcomingEvents() {
    const images = [image1,image2,image3];
  return (
    <>
        <div className="ue-container">
            <div className="ue-header">
                <h2 style={{lineHeight:"1.1"}}>Baseball Summer Camp</h2>
            </div>
            <div className="ue-content">{
                images.map((item, index) => (
  <EventContainer key={index} image={item} />
))
            }
                
            </div>
            
            <div className="video-container" style={{width: "92%", margin: "0 auto"}}>
                <div style={{position: "relative", width: "100%", paddingBottom: "56.25%"}}>
                    <video
                        controls
                        poster={COMMON_THUMBNAIL_URL}
                        style={{
                            position: "absolute",
                            top: 0,
                            left: 0,
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                            borderRadius: "12px"
                        }}
                    >
                        <source src={MEDIA_LINKS.SUMMER_CAMP.VIDEO_02} type="video/mp4" />
                        Your browser does not support the video tag.
                    </video>
                </div>
            </div>

            <hr className="scp-blurbs-hr"/>
        </div>
    </>
  )
}
